import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { postAllData } from '../../../service/ProductService';
import { STATISTICSVALIDATIONREPORT } from '../../../config/ApiConstant';
import { Calendar } from 'primereact/calendar';
import { convertLocalToUTC, exportData } from '../../../appconfig/AppHelper';
import Loader from '../../../components/Loadeer/Loader';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const StaticsReport = () => {
    document.title = 'Statics Report | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);

    //Loading/Page Loading

    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);
    const [showButton, setShowButton] = useState<boolean>(false);

    const [category, setCategory] = useState<any>({});
    const [gender, setGender] = useState<any>({});
    const [degree, setDegree] = useState<any>({});
    const [religion, setReligion] = useState<any>({});

    // Date Object
    let today = new Date();
    const [dates, setDates] = useState({
        start: new Date(today.setDate(today.getDate() - 30)),
        end: new Date()
    });

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });
    };

    useEffect(() => {
        getStaticsReport();
    }, [dates]);

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader} disabled={showButton ? false : true}></Button>
            </>
        );
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('Statistics_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    // getStaticsReportList
    const getStaticsReport = async () => {
        try {
            setShowLoading(true);

            let startDate = convertLocalToUTC(dates?.start) + ' 00:00:00';
            let endDate = convertLocalToUTC(dates?.end) + ' 23:59:59';

            // Request Data
            const requestData = {
                start_date: startDate,
                end_date: endDate
            };

            const response = await postAllData(STATISTICSVALIDATIONREPORT, requestData);

            if (response) {
                setCategory(response?.category);
                setGender(response?.gender);
                setDegree(response?.degree);
                setReligion(response?.caste);
                setShowLoading(false);
                setShowButton(true);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setShowLoading(false);
                setShowButton(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'Statistics Reports'} pageTitle={'Statistics Reports'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2 pci-register">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                    </div>
                </div>

                <div className="col-12 md:col-6">
                    <h4>Gender</h4>
                    <div className="card">
                        <div className="flex justify-content-between">
                            <h6 className="mt-0">Male</h6>
                            <h6 className="mt-0">{gender?.male}</h6>
                        </div>
                        <div className="flex justify-content-between">
                            <h6 className="mt-0">Female</h6>
                            <h6 className="mt-0">{gender?.female}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0 mb-0">Total</h6>
                            <h6 className="mt-0 mb-0">{gender?.total}</h6>
                        </div>
                    </div>
                </div>

                <div className="col-12 md:col-6">
                    <h4>Category</h4>
                    <div className="card">
                        <div className="flex justify-content-between">
                            <h6 className="mt-0">SC/ST</h6>
                            <h6 className="mt-0">{category?.sc}</h6>
                        </div>
                        <div className="flex justify-content-between">
                            <h6 className="mt-0">OBC</h6>
                            <h6 className="mt-0">{category?.obc}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0">General</h6>
                            <h6 className="mt-0">{category?.general}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0 mb-0">Total</h6>
                            <h6 className="mt-0 mb-0">{category?.total}</h6>
                        </div>
                    </div>
                </div>

                <div className="col-12 md:col-6">
                    <h4>Degree</h4>
                    <div className="card">
                        <div className="flex justify-content-between">
                            <h6 className="mt-0">Diploma</h6>
                            <h6 className="mt-0">{degree?.dpharm}</h6>
                        </div>
                        <div className="flex justify-content-between">
                            <h6 className="mt-0">BPharm</h6>
                            <h6 className="mt-0">{degree?.bpharm}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0">Pharma D</h6>
                            <h6 className="mt-0">{degree?.pharmd}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0 ">Other</h6>
                            <h6 className="mt-0 ">{degree?.other}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0 mb-0">Total</h6>
                            <h6 className="mt-0 mb-0">{degree?.total}</h6>
                        </div>
                    </div>
                </div>

                <div className="col-12 md:col-6">
                    <h4>Religion</h4>
                    <div className="card">
                        <div className="flex justify-content-between">
                            <h6 className="mt-0">Hindu</h6>
                            <h6 className="mt-0">{religion?.hindu}</h6>
                        </div>
                        <div className="flex justify-content-between">
                            <h6 className="mt-0">Muslim</h6>
                            <h6 className="mt-0">{religion?.muslim}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0">Christan</h6>
                            <h6 className="mt-0">{religion?.christan}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0 ">Sikh</h6>
                            <h6 className="mt-0 ">{religion?.sikh}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0 ">Other</h6>
                            <h6 className="mt-0 ">{religion?.other}</h6>
                        </div>
                        <div className="flex justify-content-between ">
                            <h6 className="mt-0 mb-0">Total</h6>
                            <h6 className="mt-0 mb-0">{religion?.total}</h6>
                        </div>
                    </div>
                </div>
            </div>

            {showLoading && <Loader />}
        </>
    );
};
